import React from "react";
import { Box, Card, Stack, Typography, CircularProgress, Alert } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { EstadoInventarioBadge, StockInventario } from "../ui";
import { resumenInventario } from "../../helpers/transformers";
import FechaLimiteInventario from "../ui/FechaLimiteInventario";

/**
 * Vista de tarjetas de "Mis inventarios" (preparador): la vista PRINCIPAL de
 * esta pantalla (ver pages/MisInventarios.js, DECISION), no el fallback móvil
 * que es el resto del proyecto. Cada tarjeta es tocable entera (no solo un
 * icono de acción) y navega al detalle vía onVer.
 *
 * Envuelto en React.memo: la lista de inventarios asignados puede superar 20
 * elementos y cada tarjeta no cambia salvo que cambien sus props.
 */
const MisInventariosMobileList = React.memo(({ rows, loading, onVer }) => {
    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                <CircularProgress sx={{ color: "#cc071e" }} />
            </Box>
        );
    }

    if (!rows?.length) {
        return (
            <Alert severity="info" sx={{ mt: 2 }}>
                No tienes inventarios asignados
            </Alert>
        );
    }

    return (
        <Stack spacing={2}>
            {rows.map((inventario) => {
                const { totalLineas, contadas } = resumenInventario(inventario);

                return (
                    <Card
                        key={inventario.id}
                        onClick={() => onVer(inventario)}
                        sx={{
                            p: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            cursor: "pointer",
                            "&:active": { backgroundColor: "#f8f9fa" },
                        }}
                    >
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <Stack spacing={1.5} sx={{ flex: 1 }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <StockInventario lineas={inventario.lineas} />
                                    <EstadoInventarioBadge estado={inventario.estado} />
                                </Stack>

                                <Typography sx={{ fontSize: 13, color: "#495057" }}>
                                    {contadas} de {totalLineas} artículo(s) contados
                                </Typography>

                                {inventario.fechaLimite && (
                                    <FechaLimiteInventario inventario={inventario} prefijo="Límite: " fontSize={12} />
                                )}

                                {inventario.observaciones && (
                                    <Typography
                                        sx={{
                                            fontSize: 12,
                                            color: "#6c757d",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                        }}
                                    >
                                        {inventario.observaciones}
                                    </Typography>
                                )}
                            </Stack>
                            <ChevronRightIcon sx={{ color: "#adb5bd" }} />
                        </Stack>
                    </Card>
                );
            })}
        </Stack>
    );
});

MisInventariosMobileList.displayName = "MisInventariosMobileList";

export default MisInventariosMobileList;
